import { render, staticRenderFns } from "./QuestionNumber.vue?vue&type=template&id=0328261e&scoped=true"
import script from "./QuestionNumber.vue?vue&type=script&lang=js"
export * from "./QuestionNumber.vue?vue&type=script&lang=js"
import style0 from "./QuestionNumber.vue?vue&type=style&index=0&id=0328261e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0328261e",
  null
  
)

export default component.exports